import React, { createContext, useState, useContext, useEffect } from "react";

const CityContext = createContext();

export const CityProvider = ({ children }) => {
  const [city, setCity] = useState(() => {
    return localStorage.getItem("selectedCity") || null;
  });

  // Auto detect city only if not selected
  useEffect(() => {
    if (!city && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
          );
          const data = await response.json();
          const detectedCity =
            data.address.city ||
            data.address.town ||
            data.address.state ||
            "Noida";

          setCity(detectedCity);
        } catch (error) {
          setCity("Noida");
        }
      });
    }
  }, []);

  useEffect(() => {
    if (city) {
      localStorage.setItem("selectedCity", city);
    }
  }, [city]);

  return (
    <CityContext.Provider value={{ city, setCity }}>
      {children}
    </CityContext.Provider>
  );
};

export const useCity = () => useContext(CityContext);